import LTPlatform from "../../LTGame/Platform/LTPlatform";
import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import UI_Fail from "../../ui/Main/UI_Fail";
import GameData from "../common/GameData";
import GlobalUnit from "../common/GlobalUnit";
import AudioManager from "../manager/AudioManager";
import LTSDK from "../../SDK/LTSDK";
export class UI_FailMediator extends BaseUIMediator {
    static get instance() {
        if (this._instance == null) {
            this._instance = new UI_FailMediator();
            this._instance._classDefine = UI_Fail;
        }
        return this._instance;
    }
    _OnShow() {
        super._OnShow();
        AudioManager.instance.PlayById(9);
        LTPlatform.instance.recordManager.StopRecord(null);
        this.ui.m_btn_next.onClick(this, this.NextLevel);
        this.ui.m_btn_close.onClick(this, this.OnClose);
        this.ui.m_com_level.m_text_level.text = GlobalUnit.game.level.config.level_type == 1 ? "l" + GameData.instance.levelId : '';
        this.ui.m_com_coin.m_text_count.text = GameData.instance.coinCount.toString();
        LTPlatform.instance.RecordEvent('game_ad_show', {
            level_id: GlobalUnit.game.level.config.id,
            id: 'lose_skip'
        });
        LTPlatform.instance.RecordEvent('game_result', { level_id: GlobalUnit.game.level.config.id, id: 'lose' });
        if (!LTSDK.instance.isInCheck) {
            LTPlatform.instance.ShowInterstitalAd();
        }
        this.ui.m_btn_next.visible = GlobalUnit.game.level.config.level_type == 1;
    }
    NextLevel() {
        return __awaiter(this, void 0, void 0, function* () {
            AudioManager.instance.PlayById(1);
            let res = yield LTPlatform.instance.ShowRewardVideoAdAsync();
            if (res) {
                LTPlatform.instance.RecordEvent('game_ad', {
                    level_id: GlobalUnit.game.level.config.id,
                    id: 'lose_skip'
                });
                let config = GlobalUnit.game.level.config;
                GameData.instance.levelId = config.next_id;
                GameData.SaveToDisk();
                this.Hide();
                GlobalUnit.game.GoToHome();
            }
        });
    }
    OnClose() {
        this.Hide();
        AudioManager.instance.PlayById(1);
        GlobalUnit.game.ResetGame();
    }
    _OnHide() {
    }
}
